import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import Backend from "i18next-locize-backend";
import moment from "moment";
import "moment/locale/es";
import { initReactI18next } from "react-i18next";

const locizeOptions = {
	projectId: process.env.REACT_APP_LOCIZE_PROJECTID,
	apiKey: process.env.REACT_APP_LOCIZE_APIKEY, // YOU should not expose your apps API key to production!!!
	referenceLng: process.env.REACT_APP_LOCIZE_REFLNG,
	version: process.env.REACT_APP_LOCIZE_VERSION,
};

export const LOCIZE_KEY = 'i18nextLng'

// Used to identify if production or not
const isProduction = process.env.REACT_APP_ENV == "production";
const options = {
	// order and from where user language should be detected
	order: ["localStorage", "cookie", "navigator"],

	// keys or params to lookup language from
	lookupQuerystring: 'lng',
	lookupCookie: 'i18next',
	lookupLocalStorage: LOCIZE_KEY,
	lookupSessionStorage: LOCIZE_KEY,
	lookupFromPathIndex: 0,
	lookupFromSubdomainIndex: 0,

	// cache user language on
	caches: ["localStorage", "cookie"],
	excludeCacheFor: ["cimode"], // languages to not persist (cookie, localStorage)

	// optional expiry and domain for set cookie
	cookieMinutes: 10,
	cookieDomain: "myDomain",

	// optional htmlTag with lang attribute, the default is:
	htmlTag: document.documentElement,

	// optional set cookie options, reference:[MDN Set-Cookie docs](https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Set-Cookie)
	cookieOptions: { path: "/", sameSite: "strict" },

	// optional conversion function used to modify the detected language code
	convertDetectedLanguage: "Iso15897",
	convertDetectedLanguage: (lng) => lng.replace("-", "_"),
};

if (!isProduction) {
	// locize-lastused
	// sets a timestamp of last access on every translation segment on locize
	// -> safely remove the ones not being touched for weeks/months
	// https://github.com/locize/locize-lastused
	// i18n.use(LastUsed);
}

i18n
	// .use(locizePlugin)
	.use(Backend)
	// detect user language
	// learn more: https://github.com/i18next/i18next-browser-languageDetector
	.use(LanguageDetector)
	// pass the i18n instance to react-i18next.
	.use(initReactI18next)
	// init i18next
	// for all options read: https://www.i18next.com/overview/configuration-options
	.init({
		debug: !isProduction,
		fallbackLng: "en",
		lng: "en",
		detection: options,
		supportedLngs: ["es", "en"],
		// Disable react-i18next's default Suspense mode. With it on, every component
		// calling useTranslation() for a not-yet-loaded namespace suspends, and (since
		// there is no near-by Suspense boundary) the throw bubbles to the top-level
		// BaseLayout fallback, re-showing the "Setting up your communities" loader long
		// after the initial app load. With useSuspense:false the hook returns a
		// `ready` flag instead and components render the translation key (or the
		// fallback) until the namespace arrives — a far less disruptive transition.
		react: {
			useSuspense: false,
		},
		interpolation: {
			escapeValue: false, // not needed for react as it escapes by default
			formatSeparator: ",",
			format: function (value, formatting, lng) {
				if (value instanceof Date) {
					if (lng === "es") {
						return moment(value).locale("es").format(formatting);
					} else {
						return moment(value).locale("en").format(formatting);
					}
				}
				return value.toString();
			},
		},
		// locizeLastUsed: locizeOptions,
		backend: locizeOptions,
		saveMissing: !isProduction,
	}).then(() => {
		console.log('i18n initialized with language:', i18n.language);
	});

export default i18n;
